import { useState } from 'react';
import Link from '@mui/material/Link';
import MemoryOutlinedIcon from '@mui/icons-material/MemoryOutlined';
import { DataTableActionsWrapper } from 'src/components/DataTable';
import { CellProps, Row } from 'src/components/DataTable/types';
import { SiteDeviceNodesItem } from '../../types';
import NodeDetailsViewModal from './components/NodeDetailsViewModal';

function NodesListAction({ item }: CellProps<any, Row>) {
  const row = item as unknown as SiteDeviceNodesItem;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);

  return (
    <>
      <DataTableActionsWrapper>
        <Link
          component="button"
          type="button"
          underline="hover"
          onClick={handleOpen}
          data-testid="node-gpu-cpu-details-action"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          View Details
          <MemoryOutlinedIcon fontSize="small" />
        </Link>
      </DataTableActionsWrapper>
      {open && (
        <NodeDetailsViewModal
          open={open}
          onClose={() => setOpen(false)}
          item={row}
        />
      )}
    </>
  );
}

export default NodesListAction;
